import SocialLinksComponent from '@/components/SocialLinks'
import ComboboxComponent from '@/components/Combobox'
import CheckboxComponent from '@/components/Checkbox'
import DatePickerComponent from '@/components/DatePicker'
import TimePickerComponent from '@/components/TimePicker'
import OverlayComponent from '@/components/Overlay'
import MenuButtonComponent from '@/components/MenuButton'
import FileUploadComponent from '@/components/FileUpload'
import MultipleFileUploadComponent from '@/components/MultipleFileUpload'
import ThreadMessagesComponent from '@/components/ThreadMessages'
import ThreadsComponent from '@/components/Threads'
import SignatureComponent from '@/components/Signature'
import DialogComponent from "@/components/Dialog"
import LoadingComponent from "@/components/Loading"
import PageComponent from "@/components/Page"
import GroupComponent from "@/components/Group"
import FillinComponent from "@/components/Fillin"
import LotteryChoiceComponent from "@/components/LotteryChoice"
import MultiSelectListComponent from "@/components/MultiSelectList"
import CommentCardComponent from "@/components/CommentCard"

export default [
  {
    name: 'social-links-component',
    component: SocialLinksComponent
  },
  {
    name: 'combobox-component',
    component: ComboboxComponent
  },
  {
    name: 'checkbox-component',
    component: CheckboxComponent
  },
  {
    name: 'datepicker-component',
    component: DatePickerComponent
  },
  {
    name: 'timepicker-component',
    component: TimePickerComponent
  },
  {
    name: 'overlay-component',
    component: OverlayComponent
  },
  {
    name: 'menu-button-component',
    component: MenuButtonComponent
  },
  {
    name: 'file-upload-component',
    component: FileUploadComponent
  },
  {
    name: 'multiple-file-upload-component',
    component: MultipleFileUploadComponent
  },
  {
    name: 'thread-messages-component',
    component: ThreadMessagesComponent
  },
  {
    name: 'threads-component',
    component: ThreadsComponent
  },
  {
    name: 'signature-component',
    component: SignatureComponent
  },
  {
    name: 'dialog-component',
    component: DialogComponent
  },
  {
    name: 'loading-component',
    component: LoadingComponent
  },
  {
    name: 'page-component',
    component: PageComponent
  },
  {
    name: 'group-component',
    component: GroupComponent
  },
  {
    name: 'fillin-component',
    component: FillinComponent
  },
  {
    name: 'lottery-choice-component',
    component: LotteryChoiceComponent
  },
  {
    name: 'multiselectlist-component',
    component: MultiSelectListComponent
  },
  {
    name: 'commentcard-component',
    component: CommentCardComponent
  }
]
